import { useSession, useUser } from '@descope/react-sdk';
import { TENANT_ADMIN_PERMISSION } from 'consts';
import { useMemo } from 'react';

export const useLoggedInUser = () => {
	useSession();
	const { user, isUserLoading } = useUser();

	return { user, isUserLoading };
};

export const useTenant = () => {
	const { claims } = useSession();
	const { user } = useUser();

	return useMemo(() => {
		if (!user || !claims) {
			return { tenant: null, needsSelection: false, isTenantless: false };
		}
		if (claims?.dct) {
			return {
				tenant:
					user.userTenants?.find((t) => t.tenantId === claims.dct) ?? null,
				needsSelection: false,
				isTenantless: false
			};
		}
		if (user.userTenants?.length === 1) {
			return {
				tenant: user.userTenants[0],
				needsSelection: false,
				isTenantless: false
			};
		}
		const tenantCount = user.userTenants?.length ?? 0;
		const needsSelection = tenantCount >= 2;
		return { tenant: null, needsSelection, isTenantless: tenantCount === 0 };
	}, [user, claims]);
};

export const useIsUserAdmin = () => {
	const { tenant } = useTenant();

	return useMemo(() => {
		if (!tenant) {
			return false;
		}
		return (tenant.permissions ?? []).includes(TENANT_ADMIN_PERMISSION);
	}, [tenant]);
};

export const useHasMultipleTenants = () => {
	const { user } = useLoggedInUser();

	return useMemo(() => (user?.userTenants?.length ?? 0) >= 2, [user]);
};
